<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useTheme } from 'vuetify';
import { getCurrentTheme } from './theme';
const theme = useTheme();
onMounted(() => {
  theme.global.name.value = getCurrentTheme();
});
</script>
